import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import SecondaryTripSaga from "./reducer";
const SecondaryTrip = combineReducers({
  secondaryTrips: SecondaryTripSaga,
  form: formReducer,
});

export default SecondaryTrip;
